import PropTypes from "prop-types";
import React, { useCallback } from "react";
import { Header } from "semantic-ui-react";
import { useTextResources } from "../../language";
import { dateFormat } from "../shared/constants";
import moment from 'moment'
import './style.css'

export const ReservationAddons = ({ ReservationDailyAddons }) => {
    const text = useTextResources();

    const quantity = useCallback((reservationDailyAddons) => {
        if(reservationDailyAddons.Quantity){
            return reservationDailyAddons.Quantity
        }
        return `${(reservationDailyAddons.AdultQuantity || 0)}/${(reservationDailyAddons.ChildQuantity || 0)}/${(reservationDailyAddons.InfantQuantity || 0)}`;
    }, [])

    if(!ReservationDailyAddons?.length) {
        return null;
    }

    return (
        <table className="reservation-addon-table">
              <thead>
                <tr>
                  <td>
                    <Header size='tiny'>
                      <Header.Subheader>{text('AddonName')}</Header.Subheader>
                    </Header>
                  </td>
                  <td>
                    <Header size='tiny'>
                      <Header.Subheader>{text('Date')}</Header.Subheader>
                    </Header>
                  </td>
                  <td>
                    <Header size='tiny'>
                      <Header.Subheader>{text('Quantity')}</Header.Subheader>
                    </Header>
                  </td>
                </tr>
              </thead>
              <tbody>
                {ReservationDailyAddons?.map((rda) => (
                  <tr key={rda.Id}>
                    <td>
                      <Header size='small' title={rda.HotelAddon?.ChainAddon?.Name}>
                        <Header.Content>
                          {rda.HotelAddon?.ChainAddon?.Name}
                        </Header.Content>
                      </Header>
                    </td>
                    <td>
                      <Header size='small' title={moment(rda.Date).format(dateFormat)}>
                        <Header.Content>
                          {moment(rda.Date).format(dateFormat)}
                        </Header.Content>
                      </Header>
                    </td>
                    <td>
                      <Header size='small' title={quantity(rda)}>
                        <Header.Content>
                          {quantity(rda)}
                        </Header.Content>
                      </Header>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
    )
}

ReservationAddons.propTypes = {
    ReservationDailyAddons: PropTypes.array.isRequired
}